<template>
  <modal-notification :active="active" title="Récurrence" @closed="$emit('closed')">
    <p class="mb-2">
      Attention la commande récurrente de <vue-tag class="py-0">{{ recurrence.customer.name }}</vue-tag>
      n'a pas pu être générée car le produit <vue-tag class="py-0">{{ product.name }}</vue-tag> n'est pas actif.
    </p>
    <vue-alert type="info" icon="broadcast-solid" class="mt-6">
      <template v-if="allowedToRegenerate">
        Il vous reste <strong v-text="timeLeftToRegenerate"></strong> pour essayer de régénérer la récurrence.
      </template>
      <template v-else>
        Vous ne pouvez plus régénérer cette récurrence.
      </template>
    </vue-alert>
    <vue-button slot="actions"
                class="btn btn-primary w-full md:w-auto mb-2 md:mb-0"
                :disabled="!allowedToRegenerate"
                :status="status"
                @click="regenerate">Régénérer</vue-button>
  </modal-notification>
</template>

<script>
/*  globals axios route */

import modal from '../../mixins/modal';
import regenarateRecurringOrder from '../../mixins/regenerateRecurringOrder';
import ModalNotification from './NotificationModal.vue';

export default {
  mixins: [modal, regenarateRecurringOrder],

  components: { ModalNotification },

  methods: {
    canRegenerate() {
      return axios
        .get(route('api.products.show', this.product.id))
        .then(({ data }) => data.data.active)
        .catch(() => false);
    },

    cannotRegenerateHook() {
      this.$notify({
        type: 'error',
        title: 'Erreur',
        text: 'Le produit est toujours inactif.',
      });
    },

    afterSuccessHook() {
      this.$modal.close('notification-recurring-order-product-not-active');
    },
  },
};
</script>